<template>
    <article class="article card card--article">
        <header class="card__meta">
            <p class="card__created">{{ created }}</p>
        </header>
        <router-link class="card__link-wrapper" :to="`/article${path}`">
            <section>
                <h3 class="card__title">{{ title }}</h3>
            </section>
            <footer class="card__actions">
                <Button display="link" role="link" class="card__link" @click="$router.push(`/article${path}`)">
                    Read More <div class="arrow"><SVGlink-arrow /></div>
                </Button>
            </footer>
        </router-link>
    </article>
</template>

<script>
export default {
  props: {
      image: {
          type: String,
      },
      created: {
          type: String,
          required: true,
      },
      title: {
          type: String,
          required: true,
      },
      id: {
          type: [String, Number],
          required: true,
      },
      path: {
          type: String,
          required: true
      }
  },
}
</script>

